import { JobType } from "../../types";
import { Job } from "./job.interface";

/**
 * 職種に対するを操作を提供するサービス
 */
export class JobService {
  /**
   * 全ての職種を検索します。
   */
  async findAll(): Promise<Job[]> {
    return [
      {
        visible: true,
        type: JobType.MeisterShoes,
        name: 'Meister/Shoes',
        nameJp: '靴職人',
        enabledVisit: false,
        overview:
`
靴職人

世界中のお客様へ、ものづくりの精神が宿る最高の1足を。
`,
        feature:
`
マイスターはHOSHINOの根幹を支えるポジションです。世界に誇るクラフツマンシップの体現者として、質の高い靴づくりを実現します。
社内のデジタルトランスフォメーションが進み、より最適化される生産管理のもと、各工程ごとにスピード感を伴い上質な製品を仕立て上げます。
各工程を担当する他のメンバーと共に、全体像を共有し、チームの垣根を超え、時に横断的に業務を行います。

マイスターチームは現在主にビスポークシューズにおける企画、製甲、底付、仕上の各工程に携わります。ここには婦人向けのパンプス及び婦人/紳士向けのスニーカーが含まれます。
今後、バッグ、革小物、紳士靴など商材のバリエーションが広がる中、自身の能力と希望を考慮し、最適なポジションへのアサインを行います。

全ての工程を社内で行い、日本で最もビスポークシューズを手掛けるHOSHINOは、靴職人にとって最も刺激的な環境といえます。
靴職人をリスペクトする社風は条件面にも反映されており、充実した福利厚生のほか、外部講師を招いての勉強会を行うなど入社後も成長の機会に溢れています。
`,
        contents: [
`
業務内容
各カテゴリー、各工程毎により異なります。
前職の経験やご希望を考慮し、最適なチームへアサインされます。
入社後の別カテゴリー、別工程への移動も可能です。

・企画 / デザイン工程 ( 紳士靴 / 婦人靴 )
・開発工程 ( 紳士靴 / 婦人靴 )
・裁断 / 製甲工程 ( 紳士靴 / 婦人靴 )
・釣込 / 底付工程 ( 紳士靴 / 婦人靴 / ハンドソーン / セメンテッド )
・仕上 / 検品工程 ( 紳士靴 / 婦人靴 )
・購買 / 生産管理
`,`
歓迎するスキル
製甲、底付などの靴製作における実務経験。
バッグ、革小物などものづくりにおける実務経験。
英語や中国語などの語学力。
`,`
勤務地
東京銀座店舗
東京人形町工房
`,`
勤務時間・休日
シフト制（実働 8時間、休憩 1時間）
月曜・火曜 定休日
`,`
給与
207,000 円 -( アソシエイト )
300,000 円 -( マイスター )
500,000 円 -( シェフ )
*月給制/職能による/固定残業20時間/月を含む
`,`
休暇
年次有給休暇 / 年末年始休暇 / 夏季休暇 / 介護休暇 / 産前 産後休暇 / 育児休暇 / 慶弔休暇
`,`
諸手当
各種社会保険完備
時間外手当 / 職能手当 / 技能手当 / 通勤手当 / 出張手当 / 厚生手当 / 家賃手当あり
`,`
試用期間
6か月
`,`
制度
熟練の職人による技術教育制度
技術考査制度
海外研修制度
`,
        ],
        images: [
          {src: '/images/job/job-mis_001.jpg'},
          {src: '/images/job/job-mis_002.jpg'},
        ],
      },
      {
        visible: false,
        type: JobType.MeisterBags,
        name: 'Meister/Bags',
        nameJp: '鞄職人',
        enabledVisit: false,
        overview:
`
鞄職人（かばん、革小物）

HOSHINOだからこそ提案できるかばん、革小物を世界中に届けるために。
`,
        feature:
`
HOSHINOが設立依頼提案してきた質の良いものを長く使うという価値観、そしてビスポークオーダーで培った革素材の豊富な知見をベースに、2021年、新たな取り組みが始まります。

社交の場で活躍する小さなバッグ、普段使いの大きなかばん、チェーンウォレットなど、HOSHINOだからこそ提案できるかばん、革小物の制作を予定。

クラフツマンシップに敬意を払い、手作業で仕立てる上質な製品作りに携わりませんか。

マイスターは、HOSHINOの根幹を支えるポジションです。
世界に誇るクラフツマンシップの体現者として、質の高い革製品（かばん、革小物）づくりを実現します。
社内のデジタルトランスフォメーションが進み、より最適化される生産管理のもと、各工程ごとにスピード感を伴い上質な製品を仕立て上げます。
各工程を担当する他のメンバーと共に、全体像を共有し、チームの垣根を超え、時に横断的に業務を行います。

マイスターチームは現在主にかばん、革小物における企画、製甲、底付、仕上の各工程に携わります。ここには婦人向け及び紳士向けどちらの製品も含まれます。
今後、さらに商材のバリエーションが細分化され広がる中、自身の能力と希望を考慮し、最適なポジションへのアサインを行います。

全ての工程を社内で行い、日本で最もビスポークシューズを手掛けるHOSHINOは、職人にとって最も刺激的な環境といえます。
職人をリスペクトする社風は条件面にも反映されており、充実した福利厚生のほか、外部講師を招いての勉強会を行うなど入社後も成長の機会に溢れています。、外部講師を招いての勉強会を行うなど入社後も成長の機会に溢れています。
`,
        contents: [
`
業務内容
各カテゴリー、各工程毎により異なります。
前職の経験やご希望を考慮し、最適なチームへアサインされます。
入社後の別カテゴリー、別工程への移動も可能です。

・企画 / デザイン工程 ( バッグ / 革小物 )
・開発工程( バッグ / 革小物 )
・裁断 / 製甲工程( バッグ / 革小物 )
・釣込 / 底付工程 ( バッグ、革小物 / ハンドソーン / セメンテッド )
・仕上 / 検品工程 ( バッグ / 革小物 )
・購買 / 生産管理
`,`
歓迎するスキル
バッグ、革小物などものづくりにおける実務経験。
英語や中国語などの語学力。
`,`
勤務地
東京銀座店舗
東京人形町工房
`,`
勤務時間・休日
シフト制（実働 8時間、休憩 1時間）
月曜・火曜 定休日
`,`
給与
207,000 円 -( アソシエイト )
300,000 円 -( マイスター )
500,000 円 -( シェフ )
*月給制/職能による/固定残業20時間/月を含む
`,`
休暇
年次有給休暇 / 年末年始休暇 / 夏季休暇 / 介護休暇 / 産前 産後休暇 / 育児休暇 / 慶弔休暇
`,`
諸手当
各種社会保険完備
時間外手当 / 職能手当 / 技能手当 / 通勤手当 / 出張手当 / 厚生手当 / 家賃手当あり
`,`
試用期間
6か月
`,`
制度
熟練の職人による技術教育制度
技術考査制度
海外研修制度
`
        ],
        images: [
          {src: '/images/job/job-mib_001.jpg'},
          {src: '/images/job/job-mib_002.jpg'},
        ],
      },
      {
        visible: true,
        type: JobType.ClientAdvisor,
        name: 'Client Advisor',
        nameJp: '販売職',
        enabledVisit: false,
        overview:
`
販売職（クライアントアドバイザー）

自分の木型を作る。その特別な体験を喜び溢れるものにするため。
靴選びのプロとしてお客様に寄り添います。
`,
        feature:
`
クライアントアドバイザーはHOSHINOが目指す靴の在り方、クラフツマンシップ、世界中から取り寄せる上質な素材について深く理解し、HOSHINOが描く魅力的な世界をお客様へご紹介する、HOSHINOの顔となる人材です。
お客様の悩みを真摯に受け止め、丁寧かつ的確な足の計測、シューフィッティングにより各々のお客様へ靴選びにおける最善の選択をご提案します。

クライアントアドバイザーチームはメンバー全員が高いホスピタリティとHOSHINOのビジョンへの共通認識を持ち、日々の業務に取り組みます。
お客様一人一人と向き合い、メールやお電話による細やかなコミュニケーションを行い、商品お渡し後もメンテナンスのご提案などで継続した関係を築けるよう、スムーズな業務の遂行が求められます。
また、チームとして社内の生産チーム、ITチーム、マーケティングチームと連携し、最適なタイミングでお客様が求める製品、サービスについて提案し、お客様の満足度の最大化を目指します。
常にお客様の立場で物事を捉え、その視点をもって社内にお客様の声を届ける重要な役割も担います。
`,
        contents: [
`
業務内容
HOSHINOの顔として豊富な専門知識を備え、お客様に満足度の高い提案を行う。
製品の生産状況を把握し、お客様へ進捗状況を共有する。
様々なチャネルから届くお客様からのお問い合わせに対応する。
店舗を清潔に保ち、お客様へ居心地の良い空間を提供する。
`,`
歓迎するスキル
お客様への丁寧な対応、付加価値の高い接客の経験
ビスポークシューズ（婦人 / 紳士）、バッグ、革小物、エキゾチックレザーに関する専門知識
英語・北京語・広東語・アラビア語などの言語能力
`,`
勤務地
東京銀座店舗
東京表参道店舗
`,`
勤務時間・休日
シフト制（実働 8時間、休憩 1時間）
月曜・火曜 定休日
`,`
給与
250,000円 -（給与は能力と経験により応相談。）
*月給制/職能による/固定残業20時間/月を含む
`,`
休暇
年次有給休暇 / 年末年始休暇 / 夏季休暇 / 介護休暇 / 産前 産後休暇 / 育児休暇 / 慶弔休暇
`,`
諸手当
各種社会保険完備
時間外手当 / 職能手当 / 技能手当 / 通勤手当 / 出張手当 / 厚生手当 / 家賃手当あり
`
        ],
        images: [
          {src: '/images/job/job-sal_001.jpg'},
          {src: '/images/job/job-sal_002.jpg'},
        ],
      },
      {
        visible: true,
        type: JobType.ITEngineer,
        name: 'IT Engineer',
        nameJp: 'ITエンジニア',
        enabledVisit: false,
        overview:
`
ITエンジニア

デジタルからものづくりの世界を支える。
グローバルに羽ばたくHOSHINOの世界をITの力で共に広げませんか。
`,
        feature:
`
HOSHINOのITエンジニアは、より良い商品やサービスを提供するため、個人と組織のパフォーマンスの最大化を目指し、チームでITソリューションを提供します。
各部門から寄せられる各種要望、データ分析に伴うロジカルな取り組み、そして経営課題などを、各部門と密接に連携しながら、ITの力を最大限活用して解決する努力をしています。

しかし社内では未だIT化されていない業務も多く、事業規模の拡大に伴い、DXの取り組みはこれからますます重要になっていくでしょう。
対象となる分野は幅広く、日々移り行く情勢の中で迅速な対応が求められるHOSHINOのITエンジニアは、必ずあなたのキャリアに大きな影響を与えることができると信じています。

※未経験者も歓迎
未経験のかたでも、ものづくりやITに興味をもち、やる気のある方は是非ご応募ください。
皆様のご経験や現在お持ちのITスキルに応じて、プログラミング研修なども活用しながら、徐々にスキルアップをしていただくサポートを行っていきます。
`,
        contents: [
`
業務内容
HOSHINOを支える基幹システムやECサイト/HPの開発・運用保守
接客や生産管理用の各種システム、iOSアプリの開発・運用保守
ICTデバイスやソフトウェアの管理運用
`,`
歓迎するスキル
Webシステム/ECサイト開発・運用経験
TypeScript/PHP
HTML/CSS/JavaScript
React/ReactNative/Angular
Nodejs/Nestjs
MySQL/Amazon RDS
Salesforce/Shopify/Wordpress
AWS EC2/ECS/Lambda
Google Analytics/Google Data Portal
`,`
勤務地
東京人形町工房
`,`
勤務時間・休日
9:00〜18:00（実働 8時間、休憩 1時間）
月曜・火曜 定休日
`,`
給与
250,000円 -（給与は能力と経験により応相談。）
*月給制/職能による/固定残業20時間/月を含む
`,`
休暇
年次有給休暇 / 年末年始休暇 / 夏季休暇 / 介護休暇 / 産前 産後休暇 / 育児休暇 / 慶弔休暇
`,`
諸手当
各種社会保険完備
時間外手当 / 職能手当 / 技能手当 / 通勤手当 / 出張手当 / 厚生手当 / 家賃手当あり
`
        ],
        images: [
          {src: '/images/job/job-ite_001.jpg'},
        ],
      }
    ];
  }
}